import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, tipoArquivo } from './types';

export const INITIAL_STATE: tipoArquivo = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): tipoArquivo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.TIPO_ARQUIVO_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.TIPO_ARQUIVO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.TIPO_ARQUIVO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.TIPO_ARQUIVO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
